const FALLBACK_TIMEZONES = ["UTC", "America/New_York", "America/Los_Angeles"];

export const TIMEZONES = (() => {
  try {
    const supported =
      typeof Intl !== "undefined" &&
      typeof Intl.supportedValuesOf === "function"
        ? Intl.supportedValuesOf("timeZone")
        : [];

    const unique = Array.from(new Set([...supported, ...FALLBACK_TIMEZONES]));

    const withoutUtc = unique
      .filter((tz) => tz !== "UTC")
      .sort((a, b) => a.localeCompare(b));

    return ["UTC", ...withoutUtc];
  } catch {
    return FALLBACK_TIMEZONES;
  }
})();
